import React, { useState } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import sleep from 'shared-utils/src/sleep';

import CaretIcon from 'shared-vectors/icons/Caret';
import AlarmIcon from 'shared-vectors/icons/BellFilled';
import NoAlarmIcon from 'shared-vectors/icons/BellFilledOff';
import { Icon } from 'shared-vectors';

import Grid from '../../../../Grid';
import GridItem from '../../../../GridItem';
import AccordionItem from '../../../../AccordionItemUnstyled';
import ToggleSwitch from '../../../../ToggleSwitch';
import RadioInput from '../../../../RadioInput';

import { getNotificationsTitle } from '../../utils';
import { createUpdatePayload } from '../../utils/reducers';
import { notificationsValues } from '../../utils/constants';

import style, { accCls, btnCls, iconClsOn, iconClsOff } from './style';

const useStyles = createStyle(style);

const Notifications = ({
  values,
  updateFn,
  sectionTitleCls,
  isFromNotRegisteredUser = false,
}) => {
  const togglePush = () => {
    if (!values.hasPush) {
      updateFn({ type: 'updatePushFrequency', payload: notificationsValues.immediately.value });
    }
    updateFn({ type: 'updateHasPush', payload: !values.hasPush });
  }
  const toggleEmail = () => {
    if (!values.hasEmail) {
      updateFn({ type: 'updateEmailFrequency', payload: notificationsValues.immediately.value });
    }
    updateFn({ type: 'updateHasEmail', payload: !values.hasEmail });
  }

  const toggleUnregisteredNotifications = () => {
    if (!values.hasPush) {
      updateFn({ type: 'updateNotificationsFrequency', payload: notificationsValues.immediately.value });
    }
    updateFn({ type: 'updateHasNotifications', payload: !values.hasPush });
  }

  const updateFrequency = (val) => updateFn(createUpdatePayload(val));

  // helper to update also push when changing email frequency
  // email frequency is choosen by default when user is not registered
  const updateFrequencyFromNotRegisteredUser = (val) => {
    // update email frequency
    updateFn(createUpdatePayload(val));
    // but also push frequency, because they are linked together in the UI
    const valPush = val[Object.keys(val)[0]];
    const freq = { updatePushFrequency: valPush };
    updateFn(createUpdatePayload(freq));

  }

  const [trackStartEditing, setTrackStartEditing] = useState(true);

  const onStartEditing = () => {
    if (trackStartEditing) {
      sleep(300).then(() => trackGTMEvents({
        category: 'FavouriteAndAlert',
        action: 'StartEditingAlertParameter',
        label: 'Alerts',
      }, {}, true));
      setTrackStartEditing(false);
    }
  };

  const cls = useStyles();

  const labelEmail = isFromNotRegisteredUser ? 'Notifiche' : 'Notifiche via Email';


  const { hasNotifications, titStart, titEnd } = getNotificationsTitle({ values, isFromNotRegisteredUser});
  return (
    <>
      <p className={sectionTitleCls}>
        AVVISAMI DEI NUOVI ANNUNCI
      </p>
      <AccordionItem
        className={`${accCls} c-bg--w b--s b-r--m`}
        onToggle={onStartEditing}
        header={hasRotate => (
          <GridItem
            className={`pr--ms pl--ms tp--ell${hasRotate ? ' opened' : ''}`}
          >
            <Grid align="center">
              <div className={hasNotifications ? iconClsOn : iconClsOff}>
              <Icon
                name={hasNotifications ? AlarmIcon : NoAlarmIcon}
                fill
                size="ms"
                // style={hasNotifications ? { fill: '#ffb505' } : { fill: '#96a1b0' }}
              />
              </div>
              <p className="ml--ls tp-s--m tp-w--m c-txt--f5">{titStart} <strong className="tp-w--l c-txt--f5">{titEnd}</strong></p>
            </Grid>
          </GridItem>
        )}
        trigger={(opened, hasRotate) => (
          <GridItem behavior="fixed" push="left" className="pr--m c-txt--f3">
            <Icon
              name={CaretIcon}
              height="7px"
              className={`accordion-item__icon ${hasRotate ? 'rotate--180' : ''
                }`}
            />
          </GridItem>
        )}
      >
        {!isFromNotRegisteredUser &&
          (<>
            <ToggleSwitch
              label="Notifiche su App"
              enabled={values.hasPush}
              onChange={togglePush}
              txtCls="c-txt--secondary"
            />
            {values.hasPush && (
              <div className="mb--s">
                <RadioInput
                  value={values.pushFrequency}
                  filter="updatePushFrequency"
                  defaultValue={notificationsValues.immediately.value}
                  displayValue={notificationsValues.immediately.value}
                  displayValues={[notificationsValues.immediately.label, notificationsValues.daily.label]}
                  values={[notificationsValues.immediately.value, notificationsValues.daily.value]}
                  updateValue={updateFrequency}
                  className={`${cls[btnCls]} c-txt--f2 c-bg--tr is-clickable`}
                />
              </div>
            )}
            <div className="bt--s" />
          </>)
        }
        <ToggleSwitch
          label={labelEmail}
          enabled={values.hasEmail}
          onChange={isFromNotRegisteredUser ? toggleUnregisteredNotifications : toggleEmail}
          txtCls="c-txt--secondary"
        />
        {values.hasEmail && (
          <div className="mb--s">
            <RadioInput
              value={values.emailFrequency}
              filter="updateEmailFrequency"
              defaultValue={notificationsValues.immediately.value}
              displayValue={notificationsValues.immediately.value}
              displayValues={[notificationsValues.immediately.label, notificationsValues.daily.label]}
              values={[notificationsValues.immediately.value, notificationsValues.daily.value]}
              updateValue={isFromNotRegisteredUser ? updateFrequencyFromNotRegisteredUser :updateFrequency}
              className={`${cls[btnCls]} c-txt--f2 c-bg--tr is-clickable`}
            />
          </div>
        )}
      </AccordionItem>
    </>
  );
};

export default Notifications;

Notifications.propTypes = {
  values: PropTypes.instanceOf(Object),
  updateFn: PropTypes.func,
  sectionTitleCls: PropTypes.string,
};
Notifications.defaultProps = {
  values: {},
  updateFn: () => { },
  sectionTitleCls: '',
};